import { FloatingPopover } from 'components/FloatingPopover/FloatingPopover'
import { Tooltip } from 'components/Tooltip/Tooltip'

import { ReactComponent as WarningIcon } from './warning.svg'
import Styles from './ActionModal.module.scss'
import { Modal } from 'almanac-ui/Modal'

export interface CtaButtonProps {
  isMove: boolean
  isDisabled: boolean
  movingToTopLevel: boolean
  hidePopover: boolean
  hideTooltip: boolean
  title: string | undefined
  ctaText: string
  handleOnPressCta: () => void
}

export const CtaButton = ({
  isMove,
  isDisabled,
  movingToTopLevel,
  hidePopover,
  hideTooltip,
  title,
  ctaText,
  handleOnPressCta,
}: CtaButtonProps) => {
  const tooltipTitle = isMove ? 'This may affect who has access.' : 'Copied items permissions may change.'

  const moveText = () => {
    return (
      <>
        <div>
          {movingToTopLevel ? (
            <>
              1. Your selections will be removed from their location and will appear as top level folders which may have
              different access.
            </>
          ) : (
            <>1. Your selections will be visible to everyone with access to {title}</>
          )}
        </div>
        <div style={{ marginTop: '24px' }}>
          2. People with access through a previous folder will lose access to your selections unless the items are
          directly shared with them again.
        </div>
      </>
    )
  }

  const copyText = () => {
    return (
      <div>
        {movingToTopLevel ? (
          <div>Your selections will be copied as top level folders which may have different access.</div>
        ) : (
          <div>Your selections will be visible to everyone with access to {title}.</div>
        )}
      </div>
    )
  }

  const tooltipInfo = isMove ? moveText() : copyText()
  return (
    <>
      {!hidePopover && (
        <FloatingPopover
          placement="left"
          content={
            <div className={Styles.actionModalPopoverContent}>
              <div className={Styles.actionModalPopoverTitle}>{tooltipTitle}</div>
              {tooltipInfo}
            </div>
          }
        >
          <WarningIcon />
        </FloatingPopover>
      )}
      <Tooltip
        label={'Docs can only live in folders. Select or create a new folder.'}
        placement="top"
        hide={hideTooltip}
      >
        <div className={Styles.buttonWrapper}>
          <Modal.FooterButton onPress={handleOnPressCta} variant="primary" isDisabled={isDisabled} size="lg">
            {ctaText}
          </Modal.FooterButton>
        </div>
      </Tooltip>
    </>
  )
}
